var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("DELETE_CALL_FLOW_CONFIRMATION_TITLE"),
        entity: _vm.callFlowTree,
        "show-confirm-button": true,
        "show-cancel-button": true,
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-disabled": _vm.disableModalConfirm,
        "confirm-button-loading": _vm.deletingCallFlowTree
      },
      on: { close: _vm.closeModal, confirm: _vm.deleteCallFlow }
    },
    [
      _vm.loadingCallFlowTreeReferences
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("DELETE_CALL_FLOW_MODAL_CHECK_ASSOCIATION_TEXT", {
                      callFlowTreeToDeleteName: _vm.callFlowTreeToDeleteName
                    })
                  )
                }
              })
            ],
            1
          )
        : _c("div", [
            !_vm.hasReferences
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("DELETE_CALL_FLOW_MODAL_NONE_ASSOCIATION_TEXT", {
                        callFlowTreeToDeleteName: _vm.callFlowTreeToDeleteName
                      })
                    )
                  }
                })
              : _c("div", [
                  _c("p", {
                    staticClass: "m-b-10",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("DELETE_CALL_FLOW_MODAL_ASSOCIATION_TEXT", {
                          callFlowTreeToDeleteName: _vm.callFlowTreeToDeleteName
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "well well-sm m-b-10" }, [
                    _c("div", { staticClass: "form-horizontal" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("label", { staticClass: "col-md-3 control-label" }, [
                          _c("strong", [_vm._v("Campaigns")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "list-unstyled form-control-static list-text-overflow"
                            },
                            _vm._l(
                              _vm.callFlowTreeReferences.campaigns,
                              function(campaign, index) {
                                return _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `#/dashboard/campaign/${campaign.campaignId}`,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "display-text",
                                          attrs: {
                                            title: campaign.campaignName
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(campaign.campaignName) +
                                              "\n                      "
                                          ),
                                          campaign.campaignNoRoutes
                                            ? _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName:
                                                      "v-tooltip.right.hover",
                                                    value: _vm.$t(
                                                      "NO_ROUTE_SETUP_WARNING"
                                                    ),
                                                    expression:
                                                      "$t('NO_ROUTE_SETUP_WARNING')",
                                                    modifiers: {
                                                      right: true,
                                                      hover: true
                                                    }
                                                  }
                                                ],
                                                staticClass:
                                                  "fa fa-exclamation-circle text-danger f-s-14 m-l-5",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.right.hover",
                                            value: _vm.$t("VIEW_CAMPAIGN_TEXT"),
                                            expression:
                                              "$t('VIEW_CAMPAIGN_TEXT')",
                                            modifiers: {
                                              right: true,
                                              hover: true
                                            }
                                          }
                                        ],
                                        staticClass:
                                          "fa fa-external-link m-l-5",
                                        attrs: {
                                          "tooltip-placement": "right",
                                          "aria-hidden": "true"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              }
                            ),
                            0
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-horizontal m-l-10 m-r-10" }, [
                    _c("div", { staticClass: "checkbox f-s-14" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.forceDelete,
                              expression: "forceDelete"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.forceDelete)
                              ? _vm._i(_vm.forceDelete, null) > -1
                              : _vm.forceDelete
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.forceDelete,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.forceDelete = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.forceDelete = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.forceDelete = $$c
                                }
                              },
                              _vm.attestDelete
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "DELETE_CALL_FLOW_ATTEST",
                              expression: "'DELETE_CALL_FLOW_ATTEST'"
                            }
                          ]
                        })
                      ])
                    ])
                  ])
                ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }